import { createTheme } from "@mui/material/styles";
import { blue, orange } from "./palleteColors";

export const theme = createTheme({
  palette: {
    primary: blue,
    secondary: orange,
  },
});
